<template>
  <div>
    <vs-tabs :value="nav.tab">
      <vs-tab label="출입제한관리" @click="onClickTab(0)"></vs-tab>
      <vs-tab label="과거이력" @click="onClickTab(1)"></vs-tab>
    </vs-tabs>

    <table-list-page
      ref="tableListPage"
      :board-id="boardId"
      :board-slug="`board-${boardId}`"
      route-c="write|tab"
      route-u="write|update|tab"
      :permission="permission"
      :create="nav.tab === 0"
      :approval="false"
      :nav="nav"
      :heads="tableHeads"
      :getCol="tableColumn"
      :query-search-mode="false"
      :multi-print="false"
      :move-new="false"
      :move-detail="false"
      @new="onClickNew"
      @detail="onClickDetail"
    />

  </div>
</template>
<script>
import ListPage from "./List";
import WritePage from "./Write";
import TableListPage from "@/views/list/TableListPage.vue";
import * as DataUtil from "@/util/DataUtil";
import NormalDocument from "@/views/write/document/NormalDocument.vue";
import tabItems from "../../tab/tab-items";
export default {
  components: {
    NormalDocument,
    TableListPage,
    WritePage,
  },
  props: {
    tab: Object,
    permission: {
      type: Object,
      default: () => ({ c: 0, r: 0, u: 0, d: 0, v: 0 }),
    },
  },
  computed: {
    tabItems() {
      return tabItems
    },
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
    tableHeads() {
      if (ListPage) {
        const heads = ListPage.getHead(this.projectId);
        // table-list-page 에서 sort-key 로 사용하기 위해 keyName 을 추가해준다.
        if (heads.length > 0) {
          for (const head of heads) {
            head.keyName = head.name;
          }
        }

        if (parseInt(this.projectId) === 3) {
          if (heads.length > 0 && heads[0].name === "사업장명") {
            heads[0].name = "사업명";
          }
        }
        return heads;
      }
      return [];
    },
    pageType () {
      return this.postId ? "write" : "list";
    },
  },
  data() {
    return {
      nav: {
        tab: 0,
        value: {},
      },
      clickNew: false,

      board: {
        projectTitle: this.$store.state.project.projectInfo.field_name,
        writer: {}, //작성자 정보
        readonly: false, // 읽기전용인가
        isPrint: false,
        viewSaveBtn: true,
        viewRemoveBtn: true,
      },
    };
  },
  methods: {
    onClickTab(tabIndex) {
      this.clickNew = false;
      if (this.postId) {
        this.movePage("page|tab")
      } else {
        this.nav.tab = tabIndex;
        this.onClickSearch();
      }
    },
    onClickSearch() {
      this.$refs.tableListPage.onClickSearch();
    },

    tableColumn(index, value) {
      const func = {
        ...DataUtil.listTableMethods,
        getAuthUserInfo: this.getAuthUserInfo,
      };

      const __getCol = (index, value, func) => {
        const head = ListPage.getHead()[index];
        const keys = head.key.split(".");

        const keysLength = keys.length;
        if (keysLength === 1) {
          if (keys[0] === "created_at") {
            return func.getCreatedDate(value.created_at);
          }
        }

        if (keysLength > 1) {
          const content = JSON.parse(value.post_content);
          const getData = (keys) => {
            let data = content;
            for (let i = 0; i < keys.length; i++) {
              data = data[keys[i]] || "";
            }
            return data;
          };
          return getData(keys);
        }
      };

      if (ListPage.getCol) {
        return ListPage.getCol(index, value, {
          ...func,
          _getCol: __getCol,
        });
      } else {
        const data = __getCol(index, value, func);
        if (Array.isArray(data)) {
          return data.join(", ");
        }
        return data;
      }
      return "";
    },

    movePage(name, postId) {
      const route = {
        name: name,
        params: {
          proj_id: this.projectId,
          boardId: this.boardId,
          postId: postId,
          pageType: "page",
        },
        query: this.$route.query,
      };
      this.$router.push(route)
    },

    onClickNew () {
      this.$router.push({
        name: 'write|tab',
        params: {
          projId: this.projectId,
          boardId: this.boardId,
          pageType: 'write',
        },
        query: {
          _t_back: '1043/page',
        }
      })
    },
    onClickDetail(data) {
      this.$router.push({
        name: 'write|update|tab',
        params: {
          projId: this.projectId,
          boardId: this.boardId,
          pageType: 'write',
          postId: data.raw.id,
        },
        query: {
          _t_back: '1043/page',
        }
      })
    },
  }
};
</script>
<style scoped lang="scss">

</style>
